/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import {
    BrowserCacheLocation,
    BrowserStorage,
    Configuration,
    MemoryStorage,
} from "@azure/msal-browser";

export const CACHED_REQUEST_PREFIX = "msal.request";

export type TemporaryBrokerStorage = BrowserStorage | MemoryStorage<string>;

/**
 * Returns {TemporaryBrokerStorage}
 * @param {Configuration} config
 */
export function getTemporaryBrokerStorage(
    config: Configuration
): TemporaryBrokerStorage {
    try {
        return new BrowserStorage(
            config.cache?.temporaryCacheLocation ||
                BrowserCacheLocation.SessionStorage
        );
    } catch (e) {
        return new MemoryStorage();
    }
}

/**
 * Returns the request key
 * @param clientId
 */
export function getRequestKey(clientId: string): string {
    return `${CACHED_REQUEST_PREFIX}.${clientId}`;
}
